import { RecommendationGenerationLoading } from '@/components/recommendation/recommendation-generation-loading'

export default function RecommendationLoadingPreviewPage() {
  return <RecommendationGenerationLoading previewLoop />
}
